// ============================================================================
// UKRAINIAN TRANSLATIONS - CHAPTER 2: ВИХІД
// ============================================================================
// Рівні 14-26 (13 рівнів, 39 питань)

export const chapter2Translations = {
  name: 'Вихід',
  description: 'Визволення народу Божого... Пізнання Бога перетворює наше життя',
  
  spiritualWisdom: {
    principle: 'Пізнання Бога визволяє і перетворює',
    scripture: 'Пізнаєте істину, і істина зробить вас вільними (Івана 8:32)',
    application: 'Як Ізраїль був визволений з Єгипту, пізнання Бога визволяє нас із духовного рабства'
  },
  
  levels: {
    14: {
      name: 'Мойсей, Врятований з Води',
      challenge: 'Жінка завагітніла і народила сина. Побачила, що він гарний...',
      easy: {
        question: 'У що мати Мойсея його сховала?',
        options: ['Печера', 'Очеретяна корзина', 'Кошик', 'Будинок'],
        hint: 'Ця посудина плавала на Нілі',
        funFact: '🏺 Очеретяна корзина була покрита смолою для водонепроникності!'
      },
      medium: {
        question: 'Хто знайшов Мойсея в очереті?',
        options: [
          'Дочка фараона',
          'Єгипетська служниця',
          'Його сестра Міріам',
          'Єгипетський жрець'
        ],
        hint: 'Член єгипетської царської родини',
        funFact: '👑 Як не парадоксально, саме родина фараона врятувала того, хто кине йому виклик!'
      },
      hard: {
        question: 'Як Божественне Провидіння використовує навіть наших ворогів?',
        options: [
          'Навертаючи їх',
          'Спрямовуючи обставини для виконання Своїх задумів',
          'Караючи їх',
          'Ігноруючи їх'
        ],
        hint: 'Йдеться про те, щоб бачити руку Божу в подіях',
        funFact: '✨ Мойсей виріс у палаці того, хто пригнічував його народ!'
      }
    },
    
    15: {
      name: 'Невгасима Купина',
      challenge: 'Ангел Господній з\'явився йому в полум\'ї вогню...',
      easy: {
        question: 'Що мав зняти Мойсей перед невгасимою купиною?',
        options: ['Прикраси', 'Взуття', 'Плащ', 'Тюрбан'],
        hint: 'Те, що носять на ногах',
        funFact: '👡 Зняття взуття виражає повагу на святій землі!'
      },
      medium: {
        question: 'Яке ім\'я відкрив Бог Мойсею?',
        options: [
          'Господь',
          'Я Є ТОЙ, ХТО Є',
          'Всемогутній',
          'Творець'
        ],
        hint: 'Ім\'я, що виражає абсолютне буття',
        funFact: '🔥 ЯГВЕ (Я Є) розкриває вічну сутність Бога!'
      },
      hard: {
        question: 'Чому нас навчає купина, що горить, але не згорає?',
        options: [
          'Що існує магія',
          'Бог перевершує закони природи',
          'Вогонь священний',
          'Рослини магічні'
        ],
        hint: 'Йдеться про божественну природу, що перевершує наше розуміння',
        funFact: '🌿 Купина символізує, що божественна присутність освячує, не руйнуючи!'
      }
    },

    16: {
      name: 'Десять Єгипетських Кар',
      challenge: 'Фараон ожорстив своє серце і не послухав їх...',
      easy: {
        question: 'Якою була перша єгипетська кара?',
        options: ['Жаби', 'Вода перетворюється на кров', 'Мухи', 'Воші'],
        hint: 'Вона зачепила Ніл, джерело життя Єгипту',
        funFact: '🩸 Нілу поклонялися як богу, і Бог показав Свою перевагу!'
      },
      medium: {
        question: 'Якою була остання і найжахливіша з кар?',
        options: [
          'Град',
          'Темрява',
          'Смерть первістків',
          'Сарана'
        ],
        hint: 'Ця кара безпосередньо зачепила сім\'ї',
        funFact: '😢 Ця кара остаточно зламала гордість фараона і визволила Ізраїль!'
      },
      hard: {
        question: 'Чому Бог ожорстив серце фараона?',
        options: [
          'Щоб покарати його',
          'Щоб явити Свою славу і силу',
          'Зі злоби',
          'Щоб продовжити страждання'
        ],
        hint: 'Йдеться про те, щоб відкрити, хто є справжнім Богом',
        funFact: '⚡ Кари показують, що ЯГВЕ могутніший за всіх єгипетських богів!'
      }
    },

    17: {
      name: 'Пасха',
      challenge: 'Візьміть агнця... і помажте кров\'ю на обох одвірках...',
      easy: {
        question: 'Куди ізраїльтяни мали помазати кров агнця?',
        options: [
          'На одяг',
          'На одвірки і перекладини дверей',
          'На чола',
          'У чаші'
        ],
        hint: 'Біля входу в оселі',
        funFact: '🩸 Кров на дверях була знаком божественного захисту!'
      },
      medium: {
        question: 'Як мали їсти пасхального агнця?',
        options: [
          'Сидячи зручно',
          'Тільки родиною',
          'З підперезаними стегнами, із взуттям на ногах, з посохом у руці',
          'У мовчанні'
        ],
        hint: 'Готовими до відправлення',
        funFact: '🚶 Вони мали бути готові швидко вирушити до свободи!'
      },
      hard: {
        question: 'Як пасхальний Агнець прообразує Христа?',
        options: [
          'Своєю білизною',
          'Своєю замісною жертвою, що рятує від смерті',
          'Своєю лагідністю',
          'Своїм віком'
        ],
        hint: 'Йдеться про жертву, що звільняє від засудження',
        funFact: '🐑 Ісуса називають Агнцем Божим, що бере на Себе гріх світу!'
      }
    },

    18: {
      name: 'Перехід Через Червоне Море',
      challenge: 'Мойсей простяг руку свою на море...',
      easy: {
        question: 'Як ізраїльтяни перетнули море?',
        options: [
          'На човні',
          'Вплав',
          'Суходолом',
          'На плоті'
        ],
        hint: 'Морське дно стало прохідним',
        funFact: '🌊 Бог перетворив перешкоду на шлях визволення!'
      },
      medium: {
        question: 'Що сталося з єгиптянами, які переслідували?',
        options: [
          'Вони повернули назад',
          'Вони були поглинені водами',
          'Вони заблукали',
          'Вони приєдналися до Ізраїлю'
        ],
        hint: 'Води повернулися на них',
        funFact: '⚔️ Наймогутніша армія світу була знищена в одну мить!'
      },
      hard: {
        question: 'Що символізує цей перехід у нашому духовному житті?',
        options: [
          'Втечу від проблем',
          'Перехід від рабства гріха до свободи в Бозі',
          'Перевагу Ізраїлю',
          'Знищенняворогів'
        ],
        hint: 'Йдеться про духовне перетворення',
        funFact: '🗽 Червоне море представляє хрещення: смерть для ветхого, нове життя!'
      }
    },

    19: {
      name: 'Манна в Пустелі',
      challenge: 'Що це? Бо не знали, що це...',
      easy: {
        question: 'Скільки часу падала манна?',
        options: ['10 років', '20 років', '40 років', '50 років'],
        hint: 'Стільки ж, скільки років у пустелі',
        funFact: '🍞 Протягом 40 років Бог чудесним чином годував 2 мільйони людей!'
      },
      medium: {
        question: 'Що відбувалося, якщо зберігали манну більше одного дня?',
        options: [
          'Вона ставала смачнішою',
          'Вона примножувалася',
          'Вона псувалася і смерділа',
          'Вона тверділа'
        ],
        hint: 'Крім п\'ятниці для суботи',
        funFact: '🪱 Бог так навчав щоденної залежності від Нього!'
      },
      hard: {
        question: 'Чому манна навчає нас про довіру?',
        options: [
          'Запасатися на майбутнє',
          'Покладатися на щоденне провидіння Боже',
          'Працювати старанніше',
          'Ділитися порівну'
        ],
        hint: 'Йдеться про щоденну довіру',
        funFact: '🙏 Хліб наш насущний дай нам на сей день походить з цього досвіду!'
      }
    },

    20: {
      name: 'Вода зі Скелі',
      challenge: 'Вдар у скелю, і з неї вийде вода...',
      easy: {
        question: 'Як Мойсей мав ударити в скелю?',
        options: ['Рукою', 'Посохом', 'Ногою', 'Мечем'],
        hint: 'Інструмент, який дав йому Бог',
        funFact: '🪨 Проста слухняність викликала надприродне чудо!'
      },
      medium: {
        question: 'Чому в людей була спрага?',
        options: [
          'Через спеку',
          'Тому що в пустелі не було води',
          'Через довгу подорож',
          'Через хворобу'
        ],
        hint: 'Йдеться про їхнє оточення',
        funFact: '💧 Бог створив джерело води в засушливій пустелі!'
      },
      hard: {
        question: 'Як ця скеля прообразує Христа?',
        options: [
          'Своєю силою',
          'Будучи ураженою і даючи воду життя',
          'Своїм розміром',
          'Своїм місцеположенням'
        ],
        hint: 'Йдеться про джерело спасіння',
        funFact: '⚡ Павло сказав: І скеля була Христос (1 Коринтянам 10:4)!'
      }
    },

    21: {
      name: 'Десять Заповідей',
      challenge: 'Бог промовив усі слова ці, кажучи...',
      easy: {
        question: 'Де Бог дав Десять Заповідей?',
        options: ['В Єгипті', 'На горі Синай', 'У Ханаані', 'У пустелі'],
        hint: 'Свята гора з вогнем і димом',
        funFact: '🔥 Присутність Божа змусила трястися всю гору!'
      },
      medium: {
        question: 'На чому були написані Десять Заповідей?',
        options: [
          'На пергаменті',
          'На кам\'яних скрижалях перстом Божим',
          'На дереві',
          'На золоті'
        ],
        hint: 'Постійний матеріал',
        funFact: '👆 Сам Бог написав Свій закон!'
      },
      hard: {
        question: 'Яка мета закону?',
        options: [
          'Рятувати людей',
          'Відкривати гріх і показувати святу природу Бога',
          'Карати людей',
          'Поневолювати людей'
        ],
        hint: 'Йдеться про відкриття стандартів Божих',
        funFact: '📜 Закон веде нас до необхідності Христа!'
      }
    },

    22: {
      name: 'Золоте Теля',
      challenge: 'Вони зняли прикраси і принесли їх Аарону...',
      easy: {
        question: 'Що зробив народ за відсутності Мойсея?',
        options: [
          'Новий намет',
          'Золоте теля',
          'Золотий пам\'ятник',
          'Новий жертовник'
        ],
        hint: 'Предмет ідолопоклонства',
        funFact: '🐄 Вони залишили Бога визволення, щоб служити ідолу!'
      },
      medium: {
        question: 'Як Мойсей відреагував на цей гріх?',
        options: [
          'Зрадів',
          'Розгнівався і розбив скрижалі',
          'Втік',
          'Проігнорував'
        ],
        hint: 'Його лютий reaction',
        funFact: '😢 Коли закон Божий був порушений, Мойсей розбив закон!'
      },
      hard: {
        question: 'Чому людське серце схиляється до ідолів?',
        options: [
          'Через невігластво',
          'Бажання покладатися на видиме і повстання проти володарювання Божого',
          'Через диявольський вплив',
          'Через слабкість'
        ],
        hint: 'Йдеться про людську природу і бажання видимого',
        funFact: '💔 Ідолопоклонство замінює Творця творінням!'
      }
    },

    23: {
      name: 'Скинія',
      challenge: 'Нехай вони зроблять Мені святиню...',
      easy: {
        question: 'Що таке Скинія?',
        options: [
          'Палац',
          'Переносне святилище Боже',
          'Склад',
          'Школа'
        ],
        hint: 'Місце для присутності Божої',
        funFact: '⛺ Бог бажав перебувати серед Свого народу!'
      },
      medium: {
        question: 'Яке було найсвятіше місце в Скинії?',
        options: [
          'Жертовник',
          'Святе Святих',
          'Вхід',
          'Стіл хлібів'
        ],
        hint: 'Де знаходився Ковчег Завіту',
        funFact: '✨ Тільки первосвященик міг входити туди раз на рік!'
      },
      hard: {
        question: 'Що прообразувала Скинія?',
        options: [
          'Силу Ізраїлю',
          'Еммануїл, Бог з нами, виконаний Христом',
          'Важливість священиків',
          'Красу ритуалів'
        ],
        hint: 'Йдеться про Бога, що перебуває серед людей',
        funFact: '🙏 Ісус поставив Свою скинію серед нас (Івана 1:14)!'
      }
    },

    24: {
      name: 'Розвідники Ханаану',
      challenge: 'Пошли людей, щоб вивідати землю і народ...',
      easy: {
        question: 'Скільки розвідників було послано вивідати Ханаан?',
        options: ['6', '10', '12', '24'],
        hint: 'По одному від кожного племені Ізраїлевого',
        funFact: '🕵️ 12 були послані, але тільки 2 мали віру!'
      },
      medium: {
        question: 'Хто були два розвідники з вірою?',
        options: [
          'Мойсей та Аарон',
          'Ісус Навин і Халев',
          'Аарон і Міріам',
          'Гедеон і Самсон'
        ],
        hint: 'Ті, хто вижив, щоб увійти в Ханаан',
        funFact: '💪 Їхня віра була винагороджена після 40 років мандрів!'
      },
      hard: {
        question: 'Яким було наслідок невіри?',
        options: [
          'Були прощені негайно',
          'Блукали 40 років у пустелі',
          'Були покарані негайно',
          'Були вигнані'
        ],
        hint: 'Довгий наслідок',
        funFact: '😢 Страх коштував цілому поколінню входу в обітовану землю!'
      }
    },

    25: {
      name: 'Мідний Змій',
      challenge: 'Вогненні змії увійшли в народ і кусали їх...',
      easy: {
        question: 'Якого типу були змії, які кусали народ?',
        options: ['Зелені', 'Вогненні', 'Гігантські', 'Невидимі'],
        hint: 'Прикметник, що описує їхній смертельний ефект',
        funFact: '🐍 Ці змії символізували смертельні наслідки гріха!'
      },
      medium: {
        question: 'Що Бог наказав Мойсею зробити, щоб врятувати народ?',
        options: [
          'Зробити ліки',
          'Підняти мідного змія на жердині',
          'Молитися',
          'Вбити змій'
        ],
        hint: 'Акт віри',
        funFact: '⚕️ Простий акт погляду рятував - символізуючи віру!'
      },
      hard: {
        question: 'Як Ісус процитував цю подію, говорячи про хрест?',
        options: [
          'Про небезпеку гріха',
          'Як Мойсей підняв змія в пустелі, так має бути піднесений Син Людський',
          'Про необхідність слухняності',
          'Про силу молитви'
        ],
        hint: 'Йдеться про спасіння через віру',
        funFact: '✝️ Ісус був піднесений, як мідний змій, щоб врятувати грішників!'
      }
    },

    26: {
      name: 'Обітована Земля',
      challenge: 'Можеш бачити її своїми очима, але не увійдеш туди...',
      easy: {
        question: 'Хто провів Ізраїль через Йордан?',
        options: ['Мойсей', 'Аарон', 'Ісус Навин', 'Халев'],
        hint: 'Наступник Мойсея',
        funFact: '🚶 Ім\'я Ісуса Навина має те ж значення, що й Ісус: Господь рятує!'
      },
      medium: {
        question: 'Чому Мойсей не міг увійти в обітовану землю?',
        options: [
          'Був занадто старий',
          'За непослух біля вод Меріви',
          'Відмовився вести народ',
          'Був хворий'
        ],
        hint: 'Певний попередній гріх',
        funFact: '😢 Навіть Мойсей зіткнувся з наслідками непослуху!'
      },
      hard: {
        question: 'Що символізує Обітована Земля?',
        options: [
          'Матеріальне багатство',
          'Виконання обітниць Божих у Христі та наша небесна спадщина',
          'Військові перемоги Ізраїлю',
          'Кінець пустелі'
        ],
        hint: 'Йдеться про духовне виконання обітниць Божих',
        funFact: '🌿 Ханаан вказує на небесну батьківщину, яка чекає на нас!'
      }
    }
  }
};

export default chapter2Translations;
